import { render, staticRenderFns } from "./questionnaireDetail.vue?vue&type=template&id=672361f4"
import script from "./questionnaireDetail.vue?vue&type=script&lang=js"
export * from "./questionnaireDetail.vue?vue&type=script&lang=js"
import style0 from "./questionnaireDetail.vue?vue&type=style&index=0&id=672361f4&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports